module.exports = "/images/profile-and-branding.png?d51547906875dcad495a322ad8d4ca84";